export default "__VITE_ASSET__BjM67_XW__"